module.exports = __webpack_public_path__ + "static/media/caoft.a48b9ac3.png";